<template>
  <div class="user-info">

    <a-dropdown>
      <a-menu slot="overlay" @click="handleMenuClick">
        <a-menu-item key="1">
          <a-icon type="lock" />
          <span>修改密码</span>
        </a-menu-item>
      </a-menu>
      <div class="user-info">
        <div class="user-avatar"><a-icon type="user" /></div>
        <span style="padding-left: 0.4vw" class="user-name">{{ user.name }}</span>
      </div>
    </a-dropdown>
    <span @click="logout" class="logout-btn">退出</span>
  </div>
</template>
<script>
export default {
  data() {
    return {
      user: {},
    };
  },
  mounted() {
    const str = window.localStorage.getItem("user");
    if (str) {
      this.user = JSON.parse(str);
    }
  },
  methods: {
    logout() {
      window.localStorage.clear();
      this.$router.push("/login");
    },
    handleMenuClick({ key }) {
      if (key === '1') {
        // 点击修改密码菜单项，跳转到修改密码页面的路由
        this.$router.push('/change-password');
      }
    },
  },
};
</script>

<style lang="less" scoped>
.user-info {
  display: flex;
  align-items: center;
  font-size: 0.8vw;
  cursor: pointer;

  .divider {
    margin: 0 0.8vw;
  }

  img {
    height: 1.6vh;
    margin-right: 0.4vw;
    display: flex;
  }

  .user-avatar{
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: linear-gradient(135deg, #00ff96, #00d4ff);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.2rem;
  }

  .user-name{
    font-size: 1rem;
    color: #fff;
  }

  .logout-btn {
    color: #94a3b8;
    text-decoration: none;
    font-size: 0.9rem;
    transition: color 0.3s ease;
    margin-left: 1rem;
  }

  .logout-btn:hover {
    color:#00ff96;
  }
}
</style>